import * as types from '../../../../types/masters/metalPurity/metaltype/metalTypeTypes';
import * as api from '../../../../../api/masters/metalPurity/metaltype/metalTypeApi';

export const fetchMetalTypes = () => async (dispatch) => {
  dispatch({ type: types.FETCH_METAL_TYPE_REQUEST });
  try {
    const data = await api.fetchMetalTypes();
    dispatch({ type: types.FETCH_METAL_TYPE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_METAL_TYPE_FAILURE, payload: error.message });
  }
};

export const addMetalType = (metalType) => async (dispatch) => {
  try {
    const res = await api.addMetalType(metalType);
    dispatch({ type: types.ADD_METAL_TYPE_SUCCESS, payload: res });
    dispatch(fetchMetalTypes());
  } catch (error) {
    dispatch({ type: types.METAL_TYPE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateMetalType = (id, metalType) => async (dispatch) => {
  try {
    console.log('Updating metal type with ID:', id, 'Data:', metalType);
    const res = await api.updateMetalType(id, metalType);
    console.log('Update response:', res);
    dispatch({ type: types.UPDATE_METAL_TYPE_SUCCESS, payload: res });
    dispatch(fetchMetalTypes());
  } catch (error) {
    console.error('Update error:', error);
    dispatch({ type: types.METAL_TYPE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteMetalType = (id) => async (dispatch) => {
  try {
    await api.deleteMetalType(id);
    dispatch({ type: types.DELETE_METAL_TYPE_SUCCESS, payload: id });
    dispatch(fetchMetalTypes());
  } catch (error) {
    dispatch({ type: types.METAL_TYPE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setMetalTypeEdit = (metalType) => ({
  type: types.SET_METAL_TYPE_EDIT,
  payload: metalType,
});

export const clearMetalTypeEdit = () => ({
  type: types.CLEAR_METAL_TYPE_EDIT,
}); 